/*
 * © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import _useId from '@mui/utils/useId';
export var useId = function useId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var defaultId = _useId();
  return id || "Embers-".concat(defaultId === null || defaultId === void 0 ? void 0 : defaultId.slice(1, defaultId.length - 1));
};